


























import {Vue, Component, Prop} from 'vue-property-decorator';
import {Grid} from '@toast-ui/vue-grid';
import {i18nListByKey} from '@/utils/i18n';
import {warpHeaderTit} from '@/utils/grid/rendererUtils';

@Component
export default class StockHistoryLayer extends Vue {
  @Prop() private stockNo!: string;
  @Prop() private usedWms!: boolean;
  @Prop() private showFlg!: boolean;
  private closePop() {
    this.$emit('update:showFlg', false);
  }
  private gridHeader = {
    height: 30,
    columns: [
      {
        name: 'stockCnt',
        renderer: warpHeaderTit
      }
    ]
  };
  private gridOptions = {
    columnOptions: {
      resizable: true
    },
    displayRowCount: 20,
    minRowHeight: 35,
    bodyHeight: 300,
    scrollX: true,
    scrollY: true,
    pageOptions: {
      page: 1,
      perPage: 20,
      totalCount: 0
    }
  };
  private gridColumns = [
    {
      header: 'STOCK_MANAGEMENT_GRID_CHANGEDATETIME',
      name: 'changeDateTime',
      minWidth: 160,
      align: 'center'
    },
    {
      header: 'STOCK_MANAGEMENT_GRID_UPDATECNT',
      name: 'updateCnt',
      minWidth: 50,
      align: 'center'
    },
    {
      header: 'STOCK_MANAGEMENT_GRID_STOCKCNT',
      name: 'stockCnt',
      minWidth: 50,
      align: 'center'
    },
    {
      header: 'STOCK_MANAGEMENT_GRID_SAFETYSTOCKCNT',
      name: 'safetyStockCnt',
      minWidth: 50,
      align: 'center',
      formatter: (cell: any) => {
        return this.usedWms ? cell.value : '-';
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    {
      header: 'STOCK_MANAGEMENT_GRID_CONTENTS',
      name: 'contents',
      minWidth: 350,
      align: 'center'
    },
    {
      header: 'STOCK_MANAGEMENT_GRID_ADMINNAME',
      name: 'adminName',
      minWidth: 100,
      align: 'center'
    }
  ];
  private async search(page: number) {
    let request = {
      pathParams: {
        stockNo: this.stockNo
      },
      params: {
        page,
        size: 20
      }
    };
    let {data} = await this.$api.getStocksStockNoChangeHistories(request);

    const grid = this.$refs.tuiGrid as Grid;
    const pagination = grid.invoke('getPagination') as any;

    if (pagination) {
      const pageState = {
        totalCount: data.totalCount,
        page: page,
        perPage: 20
      };
      grid.invoke('resetData', data.contents, {pageState});
    } else {
      grid.invoke('resetData', data.contents);
    }
  }
  private async mounted() {
    const grid = this.$refs.tuiGrid as Grid;
    const pagination = grid.invoke('getPagination');
    if (pagination) {
      grid.invoke('on', 'beforePageMove', (ev: any) => {
        this.search(ev.page);
        ev.stop();
      });
    }
    await this.search(1);
  }
  private created() {
    this.gridColumns = i18nListByKey(this, this.gridColumns, 'header');
  }
}
